import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { useI18n } from "@/context/I18nContext";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export default function Profile() {
  const { user, updateProfile, formatApiErrorDetail } = useAuth();
  const { t } = useI18n();
  const [form, setForm] = useState({ name: user?.name || "", company: user?.company || "" });
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await updateProfile(form);
      toast.success(t("profile.saved"));
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail) || e.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="max-w-2xl mx-auto" data-testid="profile-page">
      <h1 className="font-display font-bold text-3xl md:text-4xl tracking-tight text-[#1A2F24] mb-8">
        {t("profile.title")}
      </h1>

      <div className="bg-white border border-[#E5E2D9] rounded-xl p-6 mb-6">
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label>{t("auth.email")}</Label>
            <Input value={user?.email || ""} disabled className="mt-1.5 bg-[#F1EFE7]" />
          </div>
          <div>
            <Label>{t("auth.name")}</Label>
            <Input data-testid="profile-name-input" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="mt-1.5" />
          </div>
          <div>
            <Label>{t("auth.company")}</Label>
            <Input data-testid="profile-company-input" value={form.company} onChange={(e) => setForm({ ...form, company: e.target.value })} className="mt-1.5" />
            <p className="text-xs text-[#5C6B61] mt-1">Erscheint im PDF-Bericht</p>
          </div>
          <Button type="submit" data-testid="profile-save-button" disabled={saving} className="bg-[#1A2F24] hover:bg-[#2E3B32] text-white">
            {saving ? t("common.loading") : t("profile.save")}
          </Button>
        </form>
      </div>

      <div className="bg-[#F1EFE7] border border-[#E5E2D9] rounded-xl p-6">
        <div className="text-xs uppercase tracking-wider text-[#5C6B61] mb-1">{t("profile.current_plan")}</div>
        <div className="font-display font-bold text-2xl text-[#1A2F24]">{(user?.subscription_plan || "free").toUpperCase()}</div>
      </div>
    </div>
  );
}
